import { exceptLessThanOne, getInputMinValueErrorText, getTextField } from '@lender/utils';
import _ from 'lodash';
import { mixed } from 'yup';

import { FieldInputType } from 'constants/fields';
import { FieldInputTypeValidation } from 'constants/formGenerator';

const getValidationProps = ({
  type,
  isRequired,
  noValidate,
  maxDate,
  maxDateValidationMessage,
  minDate,
  minValue,
  minDateValidationMessage,
  patternRegExp,
  validationMessage,
  isRestyled,
}) => {
  if (noValidate) {
    return {
      isRequired: false,
      noValidate,
    };
  }

  switch (type) {
    case FieldInputType.CURRENCY:
      return {
        isRequired,
        currency: /^([0-9]{0,3},?)+$/,
        exception: minValue === 0 ? /.*/ : exceptLessThanOne,
        errorText: getInputMinValueErrorText(1),
      };

    case FieldInputType.DATE:
      return {
        maxDate,
        maxDateValidationMessage,
        minDate,
        minDateValidationMessage,
        isRequired,
      };

    case FieldInputType.EMAIL:
      return { isRequired };

    case FieldInputType.TEXT_SPECIFIC_PATTERN:
      return { patternRegExp, validationMessage, isRequired };

    default:
      return {
        isRequired,
        isRestyled,
      };
  }
};

export const getFieldValidationFunction = ({
  fieldType,
  type,
  noValidate,
  required,
  disabled,
  customSchema,
  ...restProps
}) => {
  const fieldValidationFunction =
    customSchema ||
    FieldInputTypeValidation[type] ||
    FieldInputTypeValidation[fieldType] ||
    getTextField;

  if (disabled) {
    // this should avoid errors like "The schema does not contain the path. (failed at: undefined which is a type: "object")"
    return mixed();
  }

  return fieldValidationFunction(
    getValidationProps({
      type,
      noValidate,
      isRequired: required,
      ...restProps,
    }),
  ).nullable();
};

export const transformNameInModelIntoFormName = (name = '') => name.replace(/\[|\]|\./gim, '');

export const getActionBody = (config, form) =>
  Object.values(config).reduce((acc, { nameInModel }) => {
    const fieldValue = form[transformNameInModelIntoFormName(nameInModel)];
    const isOptionObject = _.isPlainObject(fieldValue) && _.has(fieldValue, 'value');

    _.set(acc, nameInModel, isOptionObject ? fieldValue.value : fieldValue);

    return acc;
  }, {});
